module.exports = __webpack_public_path__ + "img/18.ae14f09b.svg";